@if (isSearchPopupOpen()) {
  <app-search-pop (closePopup)="isSearchPopupOpen.set(false)" />
}

<app-unsaved-changes-dialog />
<app-plan-edit-dialogs />
<app-plan-edit-form-outlet />

<app-shell-base #shellBase [showDataspaceDropdown]="showDataspaceDropdown()">
  <app-sidebar
    sidebar
    class="bg-page/90 lg:bg-page border-weak duration-base fixed top-0 left-0 z-20 h-screen -translate-x-full border-r transition-[width,transform] max-lg:backdrop-blur-xs lg:relative lg:translate-x-0"
    [ngClass]="{
      'translate-x-0': shellBase.sidebarOpen(),
      'lg:w-14': shellBase.sidebarCollapsed(),
      'lg:w-56': !shellBase.sidebarCollapsed()
    }"
    [collapsed]="shellBase.sidebarCollapsed()"
    [topItems]="topSidebarItems()"
    [bottomItems]="bottomSidebarItems()"
    (headerClick)="shellBase.onSidebarHeaderClick()">
  </app-sidebar>

  <router-outlet />
</app-shell-base>
